import { Dialog, DialogContent } from "@mui/material";
import { Button, Spin } from "antd";
import React, { useContext } from "react";
import { PlaybackContext } from "../LayoutPlayback";
// import { TiTick } from "react-icons/ti";

function BufferingLoader({ handleClose }) {
  const { bufferState } = useContext(PlaybackContext);
  return (
    <Dialog
      className="playback-buffer-pop"
      open={Boolean(bufferState?.is_buffering)}
      onClose={() => {}}
      fullWidth
      maxWidth="sm"
    >
      <DialogContent className="playback-buffer-pop-content">
        <div className="text-content">
          <span className="text">{bufferState?.cause ?? ""}</span>
          <Spin />
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default BufferingLoader;
